"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.IS_LOCAL_BACKEND = void 0;
const IS_LOCAL_BACKEND = () => (process.env.GAMECASTER_REMOTE === 'true' ? false : true);
exports.IS_LOCAL_BACKEND = IS_LOCAL_BACKEND;
const pixi_js_1 = require("pixi.js");
const pixi_filters_1 = require("pixi-filters");
const card_names_1 = require("./card-names");
const items_overlay_1 = __importDefault(require("./items-overlay"));
const api_1 = require("./api");
const guess_game_backend_1 = require("@gamecaster/guess-game-backend");
let gameCasterAPI;
if ((0, exports.IS_LOCAL_BACKEND)()) {
    gameCasterAPI = new api_1.APILocalDev(guess_game_backend_1.backendSetup);
}
else {
    gameCasterAPI = new api_1.APIRemote();
}
class EventManager {
    constructor() {
        this.state = 'idle';
        this.value = null;
        this.callback = null;
        this.index = Math.random().toString(36).substring(7);
    }
    sendEvent(selectedCard) {
        gameCasterAPI.sendTX('input', 'flip', `${this.index}#${selectedCard}`);
        this.state = 'waiting';
    }
    testIfDone() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.state === 'waiting') {
                const value = yield gameCasterAPI.getRound(this.index);
                if (value) {
                    this.value = JSON.parse(value);
                    this.state = 'done';
                    if (this.callback) {
                        yield this.callback(this.value);
                    }
                }
            }
        });
    }
    done(callback) {
        this.callback = callback;
    }
}
class GuessGame {
    constructor() {
        this.event = null;
        this.selectedCard = null;
        this.jackpotValue = 0;
        this.backgroundCircles = [];
        this.rainbowColors = [0xff0000, 0xff7f00, 0xffff00, 0x00ff00, 0x0000ff, 0x8b00ff];
        this.colorIndex = 0;
        this.audio = null;
        this.sfx = null;
        this.sfxPlayNow = null;
        this.isMuted = true;
        this.songs = [
            '/assets/song1.mp3',
            '/assets/song2.mp3',
            '/assets/song3.mp3',
            '/assets/song4.mp3',
            '/assets/song5.mp3',
            '/assets/song6.mp3',
        ];
        this.app = new pixi_js_1.Application();
        // Initialize CRT filter
        this.crtFilter = new pixi_filters_1.CRTFilter({
            curvature: 20,
            lineWidth: 5,
            lineContrast: 0.4,
            verticalLine: false,
            noise: 0.3,
            noiseSize: 1,
            vignetting: 0.3,
            vignettingAlpha: 0.7,
            vignettingBlur: 0.3,
            seed: Math.random(),
            time: 0,
        });
        this.greyScaleFilter = new pixi_js_1.ColorMatrixFilter();
        this.greyScaleFilter.desaturate();
    }
    start() {
        return __awaiter(this, void 0, void 0, function* () {
            yield this.app.init({
                width: 1024,
                height: 1024,
            });
            document.body.appendChild(this.app.canvas);
            // Create ItemsOverlay after adding the canvas to the document body
            this.itemsOverlay = new items_overlay_1.default(gameCasterAPI);
            this.app.stage.filters = this.crtFilter;
            yield this.loadAssets();
            this.createAnimatedBackground();
            this.createInitialLayout();
            yield this.updateJackpot();
            setInterval(() => this.updateJackpot(), GuessGame.JACKPOT_UPDATE_INTERVAL);
            // Create audio but don't play automatically
            this.createAudio();
            // Create mute button
            this.createMuteButton();
            // Animate CRT filter
            this.app.ticker.add(() => {
                this.crtFilter.seed = Math.random();
                this.crtFilter.time += 0.5;
            });
            gameCasterAPI.connectEvents(block => {
                this.drawTextOverlay('Event at block height ' + block);
                if (this.event) {
                    this.event.testIfDone();
                }
            }, event => {
                console.log('item-event', event);
                // Update the item list when an item event occurs
                this.itemsOverlay.updateItemList();
            });
        });
    }
    loadAssets() {
        return __awaiter(this, void 0, void 0, function* () {
            pixi_js_1.Assets.addBundle('fonts', [
                { alias: 'oswald', src: '/assets/Oswald-VariableFont_wght.ttf', data: { family: 'Oswald' } },
            ]);
            yield Promise.all([
                pixi_js_1.Assets.loadBundle('fonts'),
                ...Array.from({ length: 9 }, (_, i) => pixi_js_1.Assets.load(`/img/c${i + 1}.png`)),
                pixi_js_1.Assets.load('/img/b1.png'),
                pixi_js_1.Assets.load('/img/play_button.png'),
                pixi_js_1.Assets.load('/assets/sound.wav'),
                pixi_js_1.Assets.load('/assets/sound2.wav'),
                pixi_js_1.Assets.load('/img/mute_icon.png'),
                pixi_js_1.Assets.load('/img/unmute_icon.png'),
                // We don't need to preload all songs, we'll load them on demand
            ]);
        });
    }
    createInitialLayout() {
        this.createMainCard();
        this.createCardNameText();
        this.createJackpotText();
        this.createCardList();
        this.createPlayButton();
        this.createWalletDisplay();
        // Create a new EventManager at the start of each round
        this.event = new EventManager();
        this.updateRoundIdText();
    }
    createMainCard() {
        this.card = this.createRoundedSprite('/img/b1.png', 20); // 20 is the corner radius
        this.card.anchor.set(0.5);
        this.card.x = this.app.screen.width / 2;
        this.card.y = this.app.screen.height / 2;
        this.card.scale.set(0.3);
        this.app.stage.addChild(this.card);
    }
    createCardNameText() {
        this.cardNameText = new pixi_js_1.Text({
            text: GuessGame.DEFAULT_MESSAGE,
            style: Object.assign(Object.assign({}, GuessGame.DEFAULT_FONT_STYLE), { fontSize: 24 }),
        });
        this.cardNameText.anchor.set(0.5);
        this.cardNameText.x = this.app.screen.width / 2;
        this.cardNameText.y = this.app.screen.height / 2 + 200;
        this.app.stage.addChild(this.cardNameText);
    }
    createJackpotText() {
        const container = new pixi_js_1.Container();
        const labelText = new pixi_js_1.Text('Jackpot:', Object.assign(Object.assign({}, GuessGame.DEFAULT_FONT_STYLE), { fontSize: 24 }));
        this.jackpotNumberText = new pixi_js_1.Text('0', Object.assign(Object.assign({}, GuessGame.DEFAULT_FONT_STYLE), { fontSize: 24 }));
        this.jackpotText = new pixi_js_1.Text('TOKENS', Object.assign(Object.assign({}, GuessGame.DEFAULT_FONT_STYLE), { fontSize: 24 }));
        labelText.anchor.set(1, 0.5);
        this.jackpotNumberText.anchor.set(0.5, 0.5);
        this.jackpotText.anchor.set(0, 0.5);
        labelText.x = -10;
        this.jackpotNumberText.x = labelText.width / 2;
        this.jackpotText.x = labelText.width + 20 + this.jackpotNumberText.width;
        container.addChild(labelText, this.jackpotNumberText, this.jackpotText);
        container.x = this.app.screen.width / 2;
        container.y = 30;
        this.app.stage.addChild(container);
        // Start the rainbow animation
        this.app.ticker.add(() => this.animateJackpotColor());
    }
    animateJackpotColor() {
        this.colorIndex = (this.colorIndex + 0.01) % this.rainbowColors.length;
        const color1 = this.rainbowColors[Math.floor(this.colorIndex)];
        const color2 = this.rainbowColors[(Math.floor(this.colorIndex) + 1) % this.rainbowColors.length];
        const mix = this.colorIndex % 1;
        const color = this.lerpColor(color1, color2, mix);
        this.jackpotNumberText.style.fill = color;
    }
    lerpColor(a, b, amount) {
        const ar = a >> 16, ag = (a >> 8) & 0xff, ab = a & 0xff, br = b >> 16, bg = (b >> 8) & 0xff, bb = b & 0xff, rr = ar + amount * (br - ar), rg = ag + amount * (bg - ag), rb = ab + amount * (bb - ab);
        return (rr << 16) + (rg << 8) + (rb | 0);
    }
    createCardList() {
        this.cardListContainer = new pixi_js_1.Container();
        this.cardListContainer.x = this.app.screen.width - 350;
        this.cardListContainer.y = 220;
        for (let i = 1; i <= 9; i++) {
            const button = this.createCardButton(i);
            button.y = (i - 1) * 65;
            this.cardListContainer.addChild(button);
        }
        this.app.stage.addChild(this.cardListContainer);
    }
    getButtonStyle(isSelected = false) {
        const width = 300;
        const height = 50;
        const borderWidth = 2;
        const borderColor = 0xffffff; // White border
        const backgroundColor = isSelected ? 0x00ff00 : 0x34495e;
        const textColor = isSelected ? '#000000' : '#FFFFFF';
        return {
            width,
            height,
            borderWidth,
            borderColor,
            backgroundColor,
            textStyle: Object.assign(Object.assign({}, GuessGame.DEFAULT_FONT_STYLE), { fontSize: 24, fill: textColor }),
        };
    }
    applyButtonStyle(button, isSelected = false) {
        const style = this.getButtonStyle(isSelected);
        const border = button.getChildAt(0);
        const background = button.getChildAt(1);
        const text = button.getChildAt(2);
        border
            .clear()
            .roundRect(0, 0, style.width + style.borderWidth, style.height + style.borderWidth, 10)
            .fill(style.borderColor);
        background
            .clear()
            .roundRect(style.borderWidth / 2, style.borderWidth / 2, style.width - style.borderWidth, style.height - style.borderWidth, 10)
            .fill(style.backgroundColor);
        text.style.fill = style.textStyle.fill;
    }
    createCardButton(cardNumber) {
        const button = new pixi_js_1.Container();
        const style = this.getButtonStyle();
        const border = new pixi_js_1.Graphics();
        const background = new pixi_js_1.Graphics();
        const text = new pixi_js_1.Text({
            text: card_names_1.cardName[`c${cardNumber}`],
            style: style.textStyle,
        });
        text.anchor.set(0.5);
        text.x = style.width / 2;
        text.y = style.height / 2;
        button.addChild(border, background, text);
        this.applyButtonStyle(button);
        button.eventMode = 'static';
        button.cursor = 'pointer';
        button.on('pointerdown', () => {
            this.selectCard(cardNumber);
            this.playSoundEffect(); // Play sound effect when a card is selected
        });
        button.on('pointerover', () => {
            background.tint = 0x666666;
        });
        button.on('pointerout', () => {
            background.tint = 0xffffff;
        });
        return button;
    }
    createPlayButton() {
        this.playButton = pixi_js_1.Sprite.from('/img/play_button.png');
        this.playButton.anchor.set(0.5);
        this.playButton.x = this.app.screen.width / 2;
        this.playButton.y = this.app.screen.height - 100;
        this.playButton.scale.set(0.6);
        this.playButton.eventMode = 'static';
        this.playButton.cursor = 'pointer';
        this.playButton.on('pointerdown', () => {
            this.handlePlay();
            this.playSoundEffect(true); // Play sound effect when Play Now is pressed
        });
        this.playButton.filters = [this.greyScaleFilter]; // Apply the grey filter by default
        this.app.stage.addChild(this.playButton);
    }
    createWalletDisplay() {
        const walletAddress = gameCasterAPI.gameParams.wallet || 'Not connected';
        this.walletText = new pixi_js_1.Text({
            text: `Wallet: ${walletAddress.slice(0, 6)}...${walletAddress.slice(-4)}`,
            style: Object.assign(Object.assign({}, GuessGame.DEFAULT_FONT_STYLE), { fontSize: 16, fill: '#808080', align: 'right' }),
        });
        this.walletText.anchor.set(1, 1);
        this.walletText.x = this.app.screen.width - 20;
        this.walletText.y = this.app.screen.height - 20;
        this.app.stage.addChild(this.walletText);
    }
    selectCard(cardNumber) {
        this.selectedCard = cardNumber;
        this.cardListContainer.children.forEach((button, index) => {
            if (button instanceof pixi_js_1.Container) {
                this.applyButtonStyle(button, index + 1 === cardNumber);
            }
        });
        // Remove the grey filter when a card is selected
        this.playButton.filters = [];
        // Play sound effect when a card is selected
        this.playSoundEffect();
        // Start background music if it hasn't started yet and it's not muted
        if (!this.audio && !this.isMuted) {
            this.playRandomSong();
        }
    }
    handlePlay() {
        return __awaiter(this, void 0, void 0, function* () {
            if (this.selectedCard === null) {
                this.drawTextOverlay('Please select a card first', 0xffa500);
                return;
            }
            this.playButton.visible = false;
            this.event.sendEvent(`c${this.selectedCard}`);
            this.event.done((result) => __awaiter(this, void 0, void 0, function* () {
                console.log('result', result);
                const isWin = result.win;
                const nextCard = result.winner;
                yield this.flipCard(result.winner);
                const message = isWin
                    ? `WIN! You guessed ${card_names_1.cardName[nextCard]}`
                    : `TRY AGAIN. It was ${card_names_1.cardName[nextCard]}`;
                this.drawTextOverlay(message, isWin ? 0x2ecc71 : 0xe67e22);
                setTimeout(() => this.resetGameState(), 2000);
                yield this.updateJackpot();
            }));
            // Play "Play Now" sound effect
            this.playSoundEffect(true);
            // Start background music if it hasn't started yet and it's not muted
            if (!this.audio && !this.isMuted) {
                this.playRandomSong();
            }
        });
    }
    flipCard(nextCard) {
        return __awaiter(this, void 0, void 0, function* () {
            const cardSprite = this.card; // this.app.stage.getChild(0) as Sprite;
            const flipDuration = 30;
            const originalScale = cardSprite.scale.x;
            for (let i = 0; i <= flipDuration; i++) {
                yield new Promise(resolve => setTimeout(resolve, 16));
                const progress = i / flipDuration;
                const rotation = Math.PI * progress;
                cardSprite.skew.y = rotation;
                const scale = Math.abs(Math.cos(rotation));
                cardSprite.scale.x = originalScale * scale;
                if (i === Math.floor(flipDuration / 2)) {
                    const newTexture = this.createRoundedSprite(`/img/${nextCard}.png`, 60);
                    cardSprite.texture = newTexture.texture;
                    this.cardNameText.text = card_names_1.cardName[nextCard];
                }
            }
            // cardSprite.skew.y = 0;
            // cardSprite.scale.x = originalScale;
        });
    }
    resetGameState() {
        this.playButton.visible = true;
        this.selectedCard = null;
        // Reset the event manager
        // Create a new EventManager at the start of each round
        this.event = new EventManager();
        this.updateRoundIdText();
        this.cardListContainer.children.forEach(button => {
            if (button instanceof pixi_js_1.Container) {
                this.applyButtonStyle(button);
            }
        });
        this.card.texture = pixi_js_1.Sprite.from('/img/b1.png').texture;
        this.cardNameText.text = GuessGame.DEFAULT_MESSAGE;
        // Reapply the grey filter when resetting the game state
        this.playButton.filters = [this.greyScaleFilter];
    }
    updateJackpot() {
        return __awaiter(this, void 0, void 0, function* () {
            this.jackpotValue = yield gameCasterAPI.getCurrentJackpot();
            if (this.jackpotNumberText) {
                this.jackpotNumberText.text = this.jackpotValue.toString();
            }
            if (this.jackpotText) {
                const symbol = gameCasterAPI.gameParams.erc20symbol || 'TOKENS';
                this.jackpotText.text = symbol;
            }
        });
    }
    createAnimatedBackground() {
        const rect = new pixi_js_1.Graphics()
            .rect(0, 0, this.app.screen.width, this.app.screen.height)
            .fill(0x000000);
        this.app.stage.addChild(rect);
        const numCircles = 40;
        const colors = [0xff9999, 0x99ff99, 0x9999ff, 0xffff99, 0xff99ff, 0x99ffff];
        for (let i = 0; i < numCircles; i++) {
            const circle = new pixi_js_1.Graphics();
            const color = colors[Math.floor(Math.random() * colors.length)];
            const size = Math.random() * 50 + 20;
            circle.circle(0, 0, size).fill({ color, alpha: 0.15 });
            circle.x = Math.random() * this.app.screen.width;
            circle.y = Math.random() * this.app.screen.height;
            // Add random initial direction vector
            const angle = Math.random() * Math.PI * 2;
            const speed = Math.random() * 2 + 0.5; // Random speed between 0.5 and 2.5
            circle.vx = Math.cos(angle) * speed;
            circle.vy = Math.sin(angle) * speed;
            this.backgroundCircles.push(circle);
            this.app.stage.addChild(circle);
        }
        this.app.ticker.add(() => this.animateBackground());
    }
    animateBackground() {
        for (const circle of this.backgroundCircles) {
            circle.x += circle.vx;
            circle.y += circle.vy;
            // Bounce off the edges
            if (circle.x < 0 || circle.x > this.app.screen.width) {
                circle.vx *= -1;
            }
            if (circle.y < 0 || circle.y > this.app.screen.height) {
                circle.vy *= -1;
            }
        }
    }
    drawTextOverlay(message, color = 0xe74c3c) {
        const width = 800;
        const graphics = new pixi_js_1.Graphics()
            .rect(this.app.screen.width / 2 - width / 2, this.app.screen.height / 10 - 30, width, 60)
            .fill(color);
        const text = new pixi_js_1.Text({
            text: message,
            style: Object.assign(Object.assign({}, GuessGame.DEFAULT_FONT_STYLE), { fontSize: 40 }),
        });
        text.anchor.set(0.5);
        text.x = this.app.screen.width / 2;
        text.y = this.app.screen.height / 10;
        this.app.stage.addChild(graphics, text);
        setTimeout(() => {
            text.destroy();
            graphics.destroy();
        }, 3000);
    }
    createRoundedSprite(texture, radius) {
        const originalSprite = pixi_js_1.Sprite.from(texture);
        const graphics = new pixi_js_1.Graphics();
        graphics.roundRect(0, 0, originalSprite.width, originalSprite.height, radius).fill(0xffffff);
        const renderTexture = pixi_js_1.RenderTexture.create({
            width: originalSprite.width,
            height: originalSprite.height,
        });
        originalSprite.mask = graphics;
        this.app.renderer.render({
            container: originalSprite,
            target: renderTexture,
        });
        originalSprite.mask = null;
        return new pixi_js_1.Sprite(renderTexture);
    }
    updateRoundIdText() {
        var _a, _b;
        if (!this.roundIdText) {
            this.roundIdText = new pixi_js_1.Text({
                text: `Round ID: ${((_a = this.event) === null || _a === void 0 ? void 0 : _a.index) || 'N/A'}`,
                style: Object.assign(Object.assign({}, GuessGame.DEFAULT_FONT_STYLE), { fontSize: 16, fill: '#808080', align: 'left' }),
            });
            this.roundIdText.anchor.set(0, 1);
            this.roundIdText.x = 20;
            this.roundIdText.y = this.app.screen.height - 20;
            this.app.stage.addChild(this.roundIdText);
        }
        else {
            this.roundIdText.text = `Round ID: ${((_b = this.event) === null || _b === void 0 ? void 0 : _b.index) || 'N/A'}`;
        }
    }
    createAudio() {
        // We'll create the audio element when unmuting
        this.sfx = new Audio('/assets/sound.wav');
        this.sfxPlayNow = new Audio('/assets/sound2.wav');
    }
    createMuteButton() {
        // Start with the mute icon
        this.muteButton = pixi_js_1.Sprite.from('/img/mute_icon.png');
        this.muteButton.anchor.set(1, 0);
        this.muteButton.x = this.app.screen.width - 20;
        this.muteButton.y = 20;
        this.muteButton.scale.set(0.1);
        this.muteButton.eventMode = 'static';
        this.muteButton.cursor = 'pointer';
        this.muteButton.on('pointerdown', () => this.toggleMute());
        this.app.stage.addChild(this.muteButton);
    }
    toggleMute() {
        this.isMuted = !this.isMuted;
        if (this.isMuted) {
            this.stopAudio();
            this.muteButton.texture = pixi_js_1.Sprite.from('/img/mute_icon.png').texture;
        }
        else {
            this.playRandomSong();
            this.muteButton.texture = pixi_js_1.Sprite.from('/img/unmute_icon.png').texture;
        }
    }
    playRandomSong() {
        if (!this.isMuted) {
            const randomSong = this.songs[Math.floor(Math.random() * this.songs.length)];
            if (this.audio) {
                this.audio.pause();
                this.audio.currentTime = 0;
            }
            this.audio = new Audio(randomSong);
            this.audio.loop = true;
            this.audio.play().catch(error => console.error('Error playing audio:', error));
        }
    }
    stopAudio() {
        if (this.audio) {
            this.audio.pause();
            this.audio.currentTime = 0;
        }
    }
    playSoundEffect(isPlayNow = false) {
        if (!this.isMuted) {
            const sound = isPlayNow ? this.sfxPlayNow : this.sfx;
            if (sound) {
                sound.currentTime = 0;
                sound.play().catch(error => console.error('Error playing sound effect:', error));
            }
        }
    }
}
GuessGame.DEFAULT_MESSAGE = 'Guess the card and\nwin the up to jackpot!';
GuessGame.JACKPOT_UPDATE_INTERVAL = 30000; // 30 seconds
GuessGame.DEFAULT_FONT_STYLE = {
    fontFamily: 'Oswald',
    fontSize: 24,
    fill: '#FFFFFF',
    align: 'center',
};
// Initialization
(() => __awaiter(void 0, void 0, void 0, function* () {
    const game = new GuessGame();
    yield game.start();
}))();
